<div class="p-4">
    <jjames-card>
        <div class="flex items-center justify-between mb-6">
            <div class="flex items-center gap-4">
                <button mat-icon-button (click)="goBack()">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <div>
                    <h2 class="text-xl font-semibold">Camera Events</h2>
                    @if (camera(); as cam) {
                    <p class="text-gray-500">
                        {{ cam.deviceName }} &mdash; <span class="text-xs font-mono">{{ cam.id }}</span>
                    </p>
                    }
                </div>
            </div>
        </div>

        @if (isLoading()) {
        <div class="flex justify-center py-12">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
        }

        @if (!isLoading() && camera(); as cam) {
        <app-camera-events [camera]="cam" [parkingSpaceId]="parkingSpaceId()">
        </app-camera-events>
        }
    </jjames-card>
</div>